import { Alert, Alignment, Button, Classes, Dialog, FormGroup, Intent, Tag } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IEmpresa, IRelatorios, newEmpresa, newIRelatorios } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { toast } from "react-toastify";
import { formatCnpj, gerarPeriodos } from "../../utils";
import { RelatorioStore } from "../../stores/relatorio/RelatorioStore";
import { Pager } from "../utils/Pager";
import { DateRangePicker90 } from "../utils/DateRangePicker90";
import moment from "moment";
import { RelatoriosSelect, filterRel, renderRel } from "./relatorio/RelatoriosSelect";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { DateRangePicker30 } from "../utils/DateRangePicker30";
import { DateRangePicker } from "../utils/DateRangePicker";
import { NotasStore } from "../../stores/notas/NotasStore";

@observer
export class RelatorioPage extends React.Component<{}, {}> {

    obs = observable({
        date_periodo_relatorio: [] as any,
        selectEmpresa: newEmpresa() as IEmpresa,
        current_page: 1 as number,
        erros_relatorio: [] as any,
        relatorios: [] as any
    })

    constructor(props: any) {
        super(props);
        AppStore.setTitle("Relatório");
        RelatorioStore.handleTasksPaged(1)
        RelatorioStore.handleRelatorios()
    }

    handleCreateRelatorio() {
        if (RelatorioStore.obs.selectedEmpresa.cnpj == "") {
            toast.warning('Você precisa selecionar uma Empresa.', {});
            return
        }

        if (RelatorioStore.obs.modelo == "") {
            toast.warning('Você precisa selecionar um Modelo.', {});
            return
        }

        if (RelatorioStore.obs.tipo == "") {
            toast.warning('Você precisa selecionar um Tipo.', {});
            return
        }

        if (RelatorioStore.obs.date_start == "" || RelatorioStore.obs.date_start == "Data inválida") {
          toast.warning('Você precisa selecionar uma Data valida.', {});
          return
        }

        if (RelatorioStore.obs.date_end == "" || RelatorioStore.obs.date_end == "Data inválida") {
          toast.warning('Você precisa selecionar uma Data valida.', {});
          return
        }

        RelatorioStore.obs.open_initial = false

        if (RelatorioStore.obs.modelo == "CT-E") {
            AppStore.setLocation("/relatorio/create-cte");

        } else if (RelatorioStore.obs.modelo == "NFC-E") {
            AppStore.setLocation("/relatorio/create-nfce");

        } else if (RelatorioStore.obs.modelo == "NFS-E") {
            AppStore.setLocation("/relatorio/create-nfse");

        } else {
            AppStore.setLocation("/relatorio/create-nfe");
        }
    }

    async handleChangePage(page: number) {
        this.obs.current_page = page
        await RelatorioStore.handleTasksPaged(this.obs.current_page)
    }

    handleDateSolicitacaoChange = (val: any) => {
        var string = val.toString();
        var array = string.split(",");

        RelatorioStore.obs.date_start = moment(array[0]).format("YYYY-MM-DD")
        RelatorioStore.obs.date_end = moment(array[1]).format("YYYY-MM-DD")

        this.obs.date_periodo_relatorio = val;

        this.handleTotalNotas()

    };

    onClose() {
        RelatorioStore.obs.open_initial = false
        this.obs.date_periodo_relatorio = []
        RelatorioStore.obs.modelo = ""
        RelatorioStore.obs.tipo = ""
        RelatorioStore.obs.selectedEmpresa = newEmpresa()
        RelatorioStore.obs.select_relatorio = newIRelatorios()
    }

    handleErrosRelatorio(error: string) {
        let list_erros = error.split(",")
        this.obs.erros_relatorio = list_erros?.map(x => {
            return { "erros": x }
        })
        RelatorioStore.obs.open_erros_relatorio = true
    }

    onCloseErros() {
        RelatorioStore.obs.open_erros_relatorio = false
        this.obs.erros_relatorio = []
    }

    handleRelatorios() {
        if (RelatorioStore.obs.modelo == "NF-E") {
            return RelatorioStore.obs.relatorios.nfe
        }
        if (RelatorioStore.obs.modelo == "CT-E") {
            return RelatorioStore.obs.relatorios.cte
        }
        if (RelatorioStore.obs.modelo == "NFC-E") {
            return RelatorioStore.obs.relatorios.nfce
        }
        if (RelatorioStore.obs.modelo == "NFS-E") {
            return RelatorioStore.obs.relatorios.nfse
        }
        return []
    }

    handleOpenRelatorios() {
        this.obs.relatorios = [...RelatorioStore.obs.relatorios.nfe, ...RelatorioStore.obs.relatorios.cte, ...RelatorioStore.obs.relatorios.nfce, ...RelatorioStore.obs.relatorios.nfse]
        if (this.obs.relatorios.length == 0) {
            toast.warning('Você não possui nenhum Relatório salvo!', {});
            return
        }
        RelatorioStore.obs.open_relatorios_salvos = true
    }

    handleChangeModelo(value: string) {
      RelatorioStore.obs.modelo = value

      RelatorioStore.obs.date_start = ""
      RelatorioStore.obs.date_end = ""

      this.obs.date_periodo_relatorio = []

      this.handleTotalNotas()

    }

    async handleTotalNotas() {

      if(!RelatorioStore.obs.selectedEmpresa.cnpj) return
      if(!RelatorioStore.obs.modelo) return
      if(!RelatorioStore.obs.tipo) return
      if(!this.obs.date_periodo_relatorio.length) return
      if(this.obs.date_periodo_relatorio.includes("Data inválida")) return
      if(this.obs.date_periodo_relatorio.includes(null)) return

      let params = {
        cnpj: RelatorioStore.obs.selectedEmpresa.cnpj,
        modelo: RelatorioStore.obs.modelo,
        tipo: RelatorioStore.obs.tipo,
        periodo: gerarPeriodos(this.obs.date_periodo_relatorio)
      }

      await NotasStore.handleTotalNotas(params)

    }

    render() {
        let items = RelatorioStore.obs.tasks_relatorio?.map(imp => {
            return (
                {
                    id: imp._id,
                    cnpj: imp.cnpj,
                    razao_social: imp.razao_social,
                    inserted_at: imp.inserted_at,
                    date_start: imp.date_start,
                    date_end: imp.date_end,
                    status: imp.status,
                    relatorio_id: imp.relatorio_id,
                    error: imp.error,
                    modelo: imp.modelo,
                    tipo: imp.tipo,
                    format: imp.format
                }
            );
        });

        let empresaText = RelatorioStore.obs.selectedEmpresa.cnpj != ""
            ? `${RelatorioStore.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(RelatorioStore.obs.selectedEmpresa.cnpj)})`
            : "Selecione uma empresa";

        let relatorioText = RelatorioStore.obs.select_relatorio.nome != ""
            ? `${RelatorioStore.obs.select_relatorio.nome.substring(0, 38)}`
            : "Selecione";

        function statusFormatter(cell, row) {

          return getTag(row.status);

        }

        function fileFormatter(cell, row) {
            return (
                <>
                    <MDBBtn
                        color="default"
                        rounded
                        size="sm"
                        disabled={row.status != 2}
                        onClick={() => RelatorioStore.handleDownloadArquivoRelatorio(row.relatorio_id, row.cnpj, row.format)}
                    >
                        <img src="/images/download.svg" />
                    </MDBBtn>
                </>
            );
        }

        const errosFormatter = (cell, row) => {
            return (
                <>
                    <MDBBtn
                        color="default"
                        rounded
                        size="sm"
                        disabled={row.status != 3}
                        onClick={() => this.handleErrosRelatorio(row.error)}
                    >
                        <img src="/images/view.png" />
                    </MDBBtn>
                </>
            );
        }

        const dateFormatter = (cell, row) => {
            return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
        };

        const deleteFormatter = (cell, row) => {
            return (
                <MDBBtn color="default" rounded size="sm" onClick={() => RelatorioStore.handleDelete(row._id)}>
                    <img src="/images/bin.png" width={20} />
                </MDBBtn>
            )
        }

        const cnpjFormatter = (cell, row) => {
            return formatCnpj(row.cnpj)
        };

        return (
            <>
                <MDBRow>
                    <MDBCol xl="12" lg="12" md="12" sm="12" xs="12" className="btns-Drop">
                        <MDBBtn
                            className="btnDefault btnBuscarNfe"
                            onClick={() => RelatorioStore.obs.open_initial = true}
                            style={{ float: "left" }}
                        >
                            Solicitar Relatório
                        </MDBBtn>
                        <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => this.handleChangePage(1)} style={{float: "rigth", marginRight: 10}}>
                            Atualizar
                        </MDBBtn>
                        <MDBBtn
                            className="btnDefault btnBuscarNfe"
                            onClick={() => this.handleOpenRelatorios()}
                            style={{ float: "rigth" }}
                        >
                            Remover Relatórios Salvos
                        </MDBBtn>
                    </MDBCol>
                </MDBRow>

                <div data-tut="table">
                    <BootstrapTable className="TableDefault" ref="table" data={items}>
                        <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                        <TableHeaderColumn dataField="razao_social" width="30%">Razão Social</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={cnpjFormatter} dataField="cnpj" width="20%">CNPJ</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data do Agendamento</TableHeaderColumn>
                        <TableHeaderColumn dataField="date_start" width="15%">Período Inicial</TableHeaderColumn>
                        <TableHeaderColumn dataField="date_end" width="15%">Período Final</TableHeaderColumn>
                        <TableHeaderColumn dataField="modelo" width="10%">Modelo</TableHeaderColumn>
                        <TableHeaderColumn dataField="tipo" width="10%">Tipo</TableHeaderColumn>
                        <TableHeaderColumn dataField="status" dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivo</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={errosFormatter} width="10%">Erros</TableHeaderColumn>
                    </BootstrapTable>
                </div>

                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                    <Pager
                        currentPage={this.obs.current_page}
                        totalCount={RelatorioStore.obs.length_tasks_relatorio}
                        pageSize={15}
                        onPageChange={page => this.handleChangePage(page)}
                    />
                </div>

                <Dialog
                    isOpen={RelatorioStore.obs.open_initial}
                    onClose={() => RelatorioStore.obs.open_initial = false}
                    className="AlertUser"
                >
                    <h2 className="titleSEFAZ">Configuração inicial</h2>
                    <FormGroup
                        className="empresaSelect"
                    >
                        <EmpresaSelect
                            items={EmpresaStore.sortedEmpresas}
                            itemRenderer={renderEmpresa}
                            itemPredicate={filterEmpresa}
                            onItemSelect={(e: IEmpresa) => {
                              RelatorioStore.obs.selectedEmpresa = e;
                              this.handleTotalNotas();
                            }}
                            inputProps={{ placeholder: "Filtrar uma empresa" }}
                        >
                            <Button
                                text={empresaText}
                                rightIcon="double-caret-vertical"
                                alignText={Alignment.LEFT}
                            />
                        </EmpresaSelect>
                    </FormGroup>

                    <MDBRow>
                        <MDBCol md="6">
                            <FormGroup
                                label="Modelo"
                                className="nz-horizontal-field selectFullWidth"
                                style={{ width: "100%" }}
                            >
                                <select
                                    onChange={(e) => this.handleChangeModelo(e.target.value)}
                                    value={RelatorioStore.obs.modelo}
                                    className="bp3-button bp3-align-left"
                                >
                                    <option value="">Selecione</option>
                                    <option value="NF-E">NF-E</option>
                                    <option value="NFC-E">NFC-E</option>
                                    <option value="CT-E">CT-E</option>
                                    <option value="NFS-E">NFS-E</option>
                                </select>
                            </FormGroup>
                        </MDBCol>
                        <MDBCol md="6">
                            <FormGroup
                                label="Tipo"
                                className="nz-horizontal-field selectFullWidth"
                            >
                                <select
                                    className="bp3-button bp3-align-left"
                                    onChange={(e) => {
                                      RelatorioStore.obs.tipo = e.target.value;
                                      this.handleTotalNotas();
                                    }}
                                    value={RelatorioStore.obs.tipo}
                                >
                                    <option value="">Selecione</option>
                                    {RelatorioStore.obs.modelo == "NFS-E"
                                        ?
                                        <>
                                            <option value="Entrada">Serviços Tomados</option>
                                            <option value="Saída">Serviços Prestados</option>
                                        </>
                                        :
                                        <>
                                            <option value="Entrada">Entrada</option>
                                            <option value="Saída">Saída</option>
                                        </>
                                    }
                                </select>
                            </FormGroup>
                        </MDBCol>
                        <MDBCol md="6">
                            <FormGroup
                                label="Período de Solicitação"
                                className="inputsPeriodoCalculos"
                                style={{ width: "100%" }}
                            >
                              {RelatorioStore.obs.modelo == "NFC-E" ?
                                <DateRangePicker30
                                  onChange={this.handleDateSolicitacaoChange}
                                  value={this.obs.date_periodo_relatorio}
                                  disabled={false}
                                />
                                :
                                <DateRangePicker
                                  onChange={this.handleDateSolicitacaoChange}
                                  value={this.obs.date_periodo_relatorio}
                                />
                              }
                            </FormGroup>
                        </MDBCol>
                        <MDBCol md="6">
                            <FormGroup
                                className="empresaSelect"
                                label="Selecione um Relatório"
                            >
                                <RelatoriosSelect
                                    items={this.handleRelatorios()}
                                    itemRenderer={renderRel}
                                    itemPredicate={filterRel}
                                    onItemSelect={(e: IRelatorios) => RelatorioStore.obs.select_relatorio = e}
                                    inputProps={{ placeholder: "Filtrar um relatório" }}
                                >
                                    <Button
                                        text={relatorioText}
                                        rightIcon="double-caret-vertical"
                                        alignText={Alignment.LEFT}
                                    />
                                </RelatoriosSelect>
                            </FormGroup>
                        </MDBCol>
                    </MDBRow>

                    <p><b>Total de Notas: </b> {NotasStore.obs.total_notas}</p>

                    {RelatorioStore.obs.modelo == "NFC-E" ?
                      <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>
                        <b>Observação: Para grandes volumes de NFC-e, a exportação é realizada em CSV, considerando as restrições de tamanho e performance do formato XLSX.</b>
                      </p>
                    : <></>}

                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button text="Cancelar" onClick={() => this.onClose()} />
                        <Button text="Avançar" intent="primary" onClick={() => this.handleCreateRelatorio()} />
                    </div>
                </Dialog>

                <Alert
                    confirmButtonText="Fechar"
                    isOpen={RelatorioStore.obs.open_erros_relatorio}
                    onClose={() => this.onCloseErros()}
                    onConfirm={() => this.onCloseErros()}
                    canOutsideClickCancel={true}
                    className="AlertErrorSped"
                >
                    <h2 className="titleSEFAZ">Erros</h2>
                    <MDBCol md="12">
                        {this.obs.erros_relatorio.length &&
                            <div className="errosSped">
                                <BootstrapTable className="nomeArquivos" data={this.obs.erros_relatorio} hover>
                                    <TableHeaderColumn dataField='id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                                    <TableHeaderColumn dataField='erros' width='100%'></TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        }
                    </MDBCol>
                </Alert>

                <Alert
                    confirmButtonText="Fechar"
                    isOpen={RelatorioStore.obs.open_relatorios_salvos}
                    onClose={() => RelatorioStore.obs.open_relatorios_salvos = false}
                    onConfirm={() => RelatorioStore.obs.open_relatorios_salvos = false}
                    canOutsideClickCancel={true}
                    className="AlertErrorSped"
                >
                    <h2 className="titleSEFAZ">Relatórios</h2>
                    {this.obs.relatorios.length ?
                        <BootstrapTable className="TableDefault relatorios" data={this.obs.relatorios} search>
                            <TableHeaderColumn dataField='_id' isKey={true} hidden width='1%'>#</TableHeaderColumn>
                            <TableHeaderColumn dataField="nome" width="50%">Nome</TableHeaderColumn>
                            <TableHeaderColumn dataField="modelo" width="50%">Modelo</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={deleteFormatter} width="10%">Ações</TableHeaderColumn>
                        </BootstrapTable>
                        :
                        <></>
                    }
                </Alert>

                <LoadingModal open={RelatorioStore.obs.loading} onClose={() => RelatorioStore.obs.loading = false} title={"Baixando arquivo"} />
        </>
        )
    }
}

export default RelatorioPage;
